import React from 'react';
import { Link } from 'react-router-dom';
import { FaClock, FaReply } from 'react-icons/fa';
import DOMPurify from 'dompurify';
import { formatTimeAgo } from '../../../utils/communityUtils';
import CommunityBadge from './CommunityBadge';
import UpvoteButton from './UpvoteButton'; // we can reuse upvote button but pass reply ID logic if needed

export default function ReplyItem({ reply, onReplyClick, isNested = false }) {
  // If it's an AI reply, we style it distinctly
  const isAI = reply.isAiAssistant;

  return (
    <div className={`d-flex gap-3 mb-4 ${isNested ? 'ms-5' : ''}`}>
      {/* Avatar */}
      <div 
        className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 text-dark mt-1"
        style={{ width: '36px', height: '36px', fontSize: '14px', fontWeight: 'bold', backgroundColor: isAI ? '#ddb467' : '#e0e0e0' }}
      >
        {isAI ? '🤖' : (reply.authorName ? reply.authorName.charAt(0).toUpperCase() : 'U')}
      </div>
      
      {/* Content */}
      <div className="flex-grow-1">
        <div className="d-flex align-items-baseline gap-2 mb-1">
          <Link 
            to={isAI ? '#' : `/community/user/${reply.authorId}`} 
            className={`fw-bold text-decoration-none ${isAI ? 'text-info' : 'text-white'} ig-username hover-gold`}
            style={{ fontSize: '0.95rem' }}
          >
            {reply.authorName}
          </Link>
          {isAI ? (
            <CommunityBadge role="AI Assistant" />
          ) : (
            reply.authorCommunityRole && <CommunityBadge role={reply.authorCommunityRole} />
          )}
          <span className="text-muted small ms-1">{formatTimeAgo(reply.createdAt)}</span>
        </div>
        
        <div 
          className="text-light text-break ig-comment-text"
          style={{ fontSize: '0.95rem', lineHeight: '1.4' }}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(reply.contentHtml) }} 
        />

        {/* Reply Image */}
        {reply.imageUrls && reply.imageUrls.length > 0 && (
          <div className="mt-2">
            {reply.imageUrls.map((url, i) => (
              <img
                key={i}
                src={url}
                alt={`Reply attachment ${i + 1}`}
                className="rounded img-fluid"
                style={{ maxHeight: '250px', objectFit: 'cover', border: '1px solid #333' }}
              />
            ))}
          </div>
        )}

        {/* Actions below comment */}
        <div className="d-flex align-items-center gap-4 mt-2">
          {!isAI && onReplyClick && (
            <button 
              className="btn btn-sm text-warning fw-bold p-0 text-decoration-none hover-gold border-0 bg-transparent"
              style={{ fontSize: '0.85rem' }}
              onClick={() => onReplyClick(reply.id, reply.authorName)}
            >
              Reply
            </button>
          )}
          {/* We could add an UpvoteButton for replies if the API supports it */}
        </div>
      </div>
    </div>
  );
}
